import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      MY_MENU: "Min matkasse",
      SPECIAL_GOODS: "Dagligvarer og tillegg",
      DETAILS: "Detaljer",
      LINK_TEXT_CHANGE_ADDONS: "Velg dagligvarer",
      RECEIPT: "Kvittering",
      ORDER_VALUE: "Sammendrag",
      TEMPORARY_DELIVERY_STOP: "Midlertidig leveringsstans",
      THIS_WEEK_WE_DO_NOT_DELIVER_TO_YOUR_AREA:
        "Denne uken leverer vi ikke til ditt område.",
      NEXT_DELIVERY_IS: "Neste levering er",
      SHORT_DATE_FORMAT: "d. MMM",
    },
    se: {
      MY_MENU: "Min meny",
      SPECIAL_GOODS: "Livsmedel",
      DETAILS: "Detaljer",
      LINK_TEXT_CHANGE_ADDONS: "Välj livsmedel",
      RECEIPT: "Kvitto",
      ORDER_VALUE: "Ordervärde",
      TEMPORARY_DELIVERY_STOP: "Tillfälligt leveransuppehåll",
      THIS_WEEK_WE_DO_NOT_DELIVER_TO_YOUR_AREA:
        "Under den här veckan levererar vi inte till ditt område.",
      NEXT_DELIVERY_IS: "Nästa leverans är",
      SHORT_DATE_FORMAT: "d MMM",
    },
    dk: {
      MY_MENU: "Min menu",
      SPECIAL_GOODS: "Specialvarer og tillæg",
      DETAILS: "Detaljer",
      LINK_TEXT_CHANGE_ADDONS: "Vælg specialvarer",
      RECEIPT: "Kvittering",
      ORDER_VALUE: "Ordreværdi",
      TEMPORARY_DELIVERY_STOP: "Midlertidig leveringspause",
      THIS_WEEK_WE_DO_NOT_DELIVER_TO_YOUR_AREA:
        "I denne uge leverer vi ikke til dit område.",
      NEXT_DELIVERY_IS: "Næste levering er",
      SHORT_DATE_FORMAT: "d. MMM",
    },
  } as const
)[language];
